import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
// import Home from './views/Home.vue'
import login from './views/login.vue'
import FaultAlarmQuery from './views/EventRecord.vue'
import FaultVmiAlarmQuery from './views/EventVmiRecord.vue'
import EquipmentDashBoard from './views/MachineDashBoard.vue'
import platform from './views/platform.vue'
import EventGantt from './views/EventGantt.vue'
import ProductionAnalysis from './views/ProductionRecord.vue'
import EquipmentStepAnalysis from './views/StepCycleTime'
import SingleTireStepAnalysis from './views/SingleTireStepAnalysis'
import CycleDistribution from './views/CycleDistribution'
import ReloadingStatistics from './views/ReloadingStatistics'
import AnalogValueAnalysis from './views/AnalogValueAnalysis'
// import WC001 from './views/webCommand'//设备模拟量数据采集
import ER002 from './views/er002'
import PF001 from './views/PF001'
import DetailedStepReport from './views/DetailedStepReport'
import WorkShopDashBoard from './views/workShopDashBoard'
import FT001 from './views/FailureTime'
import PFA001  from './views/PartsFaultAlarm'
import model from './views/3dModel'
import PQ001 from './views/SemiProductQuality'
import account from './views/account'
import AnalogChartQuickView from './views/AnalogChartQuickView'//模拟量图表速览
import EquipmentUtilizationRate from './views/EquipmentUtilizationRate'//设备稼动率
import ES002 from './views/ES002'//设备详细步序报告
import ganttv2 from './views/ganttV2.vue'//新版甘特图
import DeviceServiceDownload from './views/DeviceServiceDownload'//设备服务资料下载
import EP002 from './views/EP002'//周产量分析
import EP003 from './views/EP003'//月产量分析
import tv from './views/bigScreen/tv'// 电视大屏
import demo from './views/bigScreen/demo'// 大屏轮播demo
import tvEP001 from './views/bigScreen/EP001' //电视大屏-产量分析
import tvLogin from './views/bigScreen/login' //电视大屏-登录

import grafanaLogin from './views/grafana/login' //grafana-登录
// import Readandwrite from './views/Readandwrite'//云端读写PLC标签数据
// import DataCollectionTest from './views/dataCollectionTest'//查询试数据采集测试工具
// import Connect from './views/Connect'//远程

// 赛象云后台管理 页面
// import AcquisitionModel from './views/collection/AcquisitionModel'//采集模型
// import AttributeDetails from './views/collection/AttributeDetails'//属性详情
// import SourceAdminister from './views/collection/SourceAdminister'//source数据源管理
// import TargetAdminister from './views/collection/TargetAdminister'//target数据源管理

// import AcquisitionModelDetails from './views/collection/AcquisitionModelDetails'//练习
import SC001 from './views/Dailyequipmentparameters'//设备参数日报新增
import CB001 from './views/WorkShopAlarmStatistics.vue'//车间报警统计新增
import SG001 from './views/EquipmentSpecificationInformation'//设备规格信息
// 车间故障统计报告
import workshop from "./views/WorkShopFaults.vue"
//新增导出意见建议
import DownloadSuggestions from "./views/DownloadSuggestions.vue"
//新增设备平均效率对比
import EquipmentEfficiency from "./views/EquipmentEfficiency.vue"
//新增工艺参数对比
import CompareCraft from "./views/CompareCraft.vue"
//新增工艺参数记录
import RecordCraft from "./views/RecordCraft.vue"
//新增偏置参数记录
import OffsetCraft from "./views/OffsetCraft.vue"
//新增带束位置信息
import BeamPositionInfo from "./views/BeamPositionInfo.vue"
// 微信小程序的视频播放页面
import WxViewVideo from "./views/wx/index.vue"
import grafanaAnalog from './views/grafanaAnalog' //grafana-模拟量数据（测试）

//导出用户操作记录，供赛象云科技人员查看
import EL001 from "./views/exportRequest/index.vue"

// VPN盒子
import VPN001 from "./views/VpnApply.vue"
import VPN002 from "./views/VpnReview.vue"
import VPN003 from "./views/VpnManage.vue"

Vue.use(Router)

// if (window.localStorage.getItem('token') !== null) {
//   store.commit('setHistoryToStore')
// }

const router = new Router({
  mode: 'history',//history
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'WorkShopDashBoard',
      component: WorkShopDashBoard
    },
    {
      path: '/login',
      name: 'login',
      component: login
    },
    {
      path: '/EF001',
      name: 'FaultAlarmQuery',
      component: FaultAlarmQuery
    },
    {
      path: '/EF002',
      name: 'FaultVmiAlarmQuery',
      component: FaultVmiAlarmQuery
    },
    {
      path: '/EquipmentDashBoard/:id',
      name: 'EquipmentDashBoard',
      component: EquipmentDashBoard
    },
    {
      path: '/platform',
      name: 'platform',
      component: platform
    },
    {
      path: '/EG001',
      name: 'EventGantt',
      component: EventGantt
    },
    {
      path: '/EP001',
      name: 'ProductionAnalysis',
      component: ProductionAnalysis
    },
    {
      path: '/ES001',
      name: 'EquipmentStepAnalysis',
      component: EquipmentStepAnalysis,
    },
    {
      path: '/TS001',
      name: 'SingleTireStepAnalysis',
      component: SingleTireStepAnalysis,
    },
    {
      path: '/CD001',
      name: 'CycleDistribution',
      component: CycleDistribution,
    },
    {
      path: '/ER001',
      name: 'ReloadingStatistics',
      component: ReloadingStatistics,
    },
    {
      path: '/AV001',
      name: 'AnalogValueAnalysis',
      component: AnalogValueAnalysis,
    },
    // 测试文件
     //设备模拟量数据采集
    // {
    //   path: '/WC001',
    //   name: 'WC001',
    //   component: WC001,
    // },
    {
      path: '/ER002',
      name: 'ER002',
      component: ER002,
    },
    {
      path: '/PF001',
      name: 'PF001',
      component: PF001,
    },
    {
      path: '/ES003',
      name: 'DetailedStepReport',
      component: DetailedStepReport,
    },
    {
      path: '/DB/W/:shopId',
      name: 'WorkShopDashBoard',
      component: WorkShopDashBoard
    },
    {
      path: '/FT001',
      name: 'FT001',
      component: FT001,
    },
    {
      path: '/PFA001',
      name: 'PFA001',
      component: PFA001,
    },
    {
      path: '/3dModel',
      name: 'model',
      component: model
    },
    // 半制品质量
    {
      path: '/PQ001',
      name: 'PQ001',
      component: PQ001
    },
    // 账号管理
    {
      path: '/account',
      name: 'account',
      component: account
    },
    //模拟量图表速览
    {
      path: '/AnalogChartQuickView',
      name: 'AnalogChartQuickView',
      component: AnalogChartQuickView,
    },
    
    //设备稼动率
    {
      path: '/EquipmentUtilizationRate',
      name: 'EquipmentUtilizationRate',
      component: EquipmentUtilizationRate
    },
    //设备详细步序报告
    {
      path: '/ES002',
      name: 'ES002',
      component: ES002
    },
    // 新版甘特图
    {
      path: '/TS001_V2',
      name: 'ganttv2',
      component: ganttv2
    },
    //设备服务资料下载
    {
      path: '/DeviceServiceDownload',
      name: 'DeviceServiceDownload',
      component: DeviceServiceDownload
    },
    // 周产量分析
    {
      path: '/EP002',
      name: 'EP002',
      component: EP002
    },
    // 月产量分析
    {
      path: '/EP003',
      name: 'EP003',
      component: EP003
    },
    // 电视大屏
    {
      path: '/tv',
      name: 'tv',
      component: tv
    },
    //大屏-产量分析
    {
      path: '/tv/EP001',
      name: 'tvEP001',
      component: tvEP001
    },
    //大屏-登陆
    {
      path: '/tv/login',
      name: 'tvLogin',
      component: tvLogin
    },  
    // 大屏--轮播demo
    {
      path: '/demo',
      name: 'demo',
      component: demo
    },
    //查询试数据采集测试工具
    // {
    //   path: '/DataCollectionTest',
    //   name: 'DataCollectionTest',
    //   component: DataCollectionTest
    // },
    //云端读写PLC标签数据
    // {
    //   path: '/Readandwrite',
    //   name: 'Readandwrite',
    //   component: Readandwrite
    // },
    //远程
    // {
    //   path: '/Connect',
    //   name: 'Connect',
    //   component: Connect
    // },
    //采集模型
    // {
    //   path: '/AcquisitionModel',
    //   name: 'AcquisitionModel',
    //   component: AcquisitionModel
    // },
    // //属性详情
    // {
    //   path: '/AttributeDetails/:id',
    //   name: 'AttributeDetails',
    //   component: AttributeDetails
    // },
    // //source数据源管理
    // {
    //   path: '/SourceAdminister',
    //   name: 'SourceAdminister',
    //   component: SourceAdminister
    // },
    // //target数据源管理
    // {
    //   path: '/TargetAdminister',
    //   name: 'TargetAdminister',
    //   component: TargetAdminister
    // },
    // //练习
    // {
    //   path: '/AcquisitionModelDetails',
    //   name: 'AcquisitionModelDetails',
    //   component: AcquisitionModelDetails
    // },
    // 设备参数日报
    {
      path: '/SC001',
      name: 'SC001',
      component:SC001
    },
    // 车间报警统计
    {
      path: '/CB001',
      name: 'CB001',
      component:CB001
    },
    //设备规格信息
    {
      path: '/SG001',
      name: 'SG001',
      component:SG001
    },
    // 车间故障统计报告
    {
      path: '/WFS001',
      name:'workshop',
      component:workshop
    },
     // grafana的登录页面
     {
      path:'/grafanaLogin',
      name:'grafanaLogin',
      component:grafanaLogin
    },
    {
      path:'/exportRequestLog',
      name:'EL001',
      component:EL001
    },
    // 新增导出意见建议
    {
      path: '/DownloadSuggestions',
      name:'DownloadSuggestions',
      component:DownloadSuggestions
    },
    // 新增平均效率对比
    {
      path: '/EquipmentEfficiency',
      name:'EquipmentEfficiency',
      component:EquipmentEfficiency
    },
    // 新增工艺参数对比
    {
      path: '/CompareCraft',
      name:'CompareCraft',
      component:CompareCraft
    },
    // 新增工艺参数记录
    {
      path: '/RecordCraft',
      name:'RecordCraft',
      component:RecordCraft
    },
    // 新增偏置参数记录
    {
      path: '/OffsetCraft',
      name:'OffsetCraft',
      component:OffsetCraft
    },
    // 新增带束位置信息
    {
      path: '/BeamPositionInfo',
      name:'BeamPositionInfo',
      component:BeamPositionInfo
    },
    // 新增微信小程序播放视频页面
    {
      path: '/WxViewVideo',
      name:'WxViewVideo',
      component:WxViewVideo
    },
    // 新增grafana模拟量输入嵌入页面
    {
      path: '/grafanaAnalog',
      name:'grafanaAnalog',
      component:grafanaAnalog
    },
    // VPN盒子申请
    {
      path: '/VPN001',
      name:'VPN001',
      component:VPN001
    },
    // VPN盒子审核
    {
      path: '/VPN002',
      name:'VPN002',
      component:VPN002
    },
    // VPN盒子管理
    {
      path: '/VPN003',
      name:'VPN003',
      component:VPN003
    }
  ]
})
router.beforeEach((to, from, next) => {
  let authority = JSON.parse(localStorage.getItem('authority'))
  let defaultFactoryId = Number(localStorage.getItem('defaultFactoryId'))
  if (to.name === 'EquipmentStepAnalysis') {
    store.commit('clearData')
    next()
  } else if (to.name === 'EventGantt'){
    store.state.axiosPromiseArr.forEach((ele, index) => {
      ele.cancel()
      delete store.state.axiosPromiseArr[index]
    })
    next()
  } else {
    store.state.axiosPromiseArr.forEach((ele, index) => {
      ele.cancel()
      delete store.state.axiosPromiseArr[index]
    })
    next()
  }
  if(to.name === 'CompareCraft'){
    let isMenuCompareCraft =(authority.ComparisonCurrentProcessParameters.show===true) && (defaultFactoryId ===2 || defaultFactoryId ===17)
    if(isMenuCompareCraft===true)next()
    else next('/');
  }else if(to.name === 'RecordCraft'){
    let isMenuRecordCraft =(authority.ProcessParameterRecord.show===true) && (defaultFactoryId ===2 || defaultFactoryId ===17)
    if(isMenuRecordCraft===true)next()
    else next('/');
  }else if(to.name === 'OffsetCraft'){
    let isMenuOffsetCraft =(authority.OffsetParameterRecord.show===true) && (defaultFactoryId ===2 || defaultFactoryId ===17)
    if(isMenuOffsetCraft===true)next()
    else next('/');
  }
});

const originalPush = Router.prototype.push
Router.prototype.push = function push (location) {
  return originalPush.call(this, location)
}
export default router